import React, { Fragment, useEffect, useRef } from 'react';

import { Box, Divider, IconButton, Tooltip } from '@mui/material';
import { type TBlock } from '@wp-block-builder/package';

import { NavigationTreeOutlined } from '@waypoint/react/icons';

import { useBlockAncestors, useCurrentBlockElement, useNavigationBarMode } from '../../../../editor/hooks';

import BlockTab from './BlockTab';

type Props = {
  block: TBlock;
  error: boolean;
};
export default function CurrentSectionTab({ block, error }: Props) {
  const ref = useRef<HTMLElement>(null);
  const [currentAnchorElement, setCurrentAnchorElement] = useCurrentBlockElement();
  const ancestors = useBlockAncestors(block.id);
  const [, setNavigationBarMode] = useNavigationBarMode();

  const onNavigatorOpenClick = () => {
    setNavigationBarMode('VISIBLE');
  };

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const parent = ref.current.parentElement;
    if (parent === currentAnchorElement) {
      return;
    }
    setCurrentAnchorElement(parent);
  }, [ref, currentAnchorElement, setCurrentAnchorElement]);

  return (
    <Box
      ref={ref}
      sx={{
        cursor: 'pointer',
        bgcolor: error ? 'brand.red' : 'brand.blue',
        color: 'white',
        display: 'inline-flex',
        position: 'absolute',
        top: -24,
        left: -1,
        height: 24,
        gap: 0.5,
        px: 1,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 'fab',
      }}
    >
      {ancestors.map((b, i) => (
        <Fragment key={i}>
          <BlockTab reverseIndex={ancestors.length - i} block={b} />
          {' / '}
        </Fragment>
      ))}
      <BlockTab reverseIndex={0} block={block} />

      <Divider
        orientation="vertical"
        sx={{
          borderColor: 'rgba(255,255,255,0.2)',
          px: 0.25,
        }}
      />
      <Tooltip title="Show in navigator">
        <IconButton size="small" onClick={onNavigatorOpenClick} color="inherit">
          <NavigationTreeOutlined sx={{ fontSize: 15 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
